import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger, Toastr } from 'data/common';
import api from './api';
import Translator from '../../../../../../translator';
const apiCaller = getApiInstance();
export function getBrands(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllBrands(env))
            .then(({ data }) => {
                if (data.success) {
                    if (data.brands) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_BRANDS`,
                            brands: data.brands,
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getBrands - ', error);
                throw error;
            });
    };
}

export function getBrandDetails(env, brandId) {
    return dispatch => {
        return apiCaller
            .call(api.getBrandDetails(env, brandId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_BRAND`,
                        brandId,
                        brand: data.brand,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getBrandDetails - ', error);
                throw error;
            });
    };
}

export function updateBrandDetails(env, brandId, form) {
    return dispatch => {
        return apiCaller
            .call(api.updateBrandDetails(env, brandId, form))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_BRAND`,
                        brandId,
                        brand: data.brand,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateBrand - ', error);
                throw error;
            });
    };
}

export function addBrand(env, brandForm) {
    return dispatch => {
        return apiCaller
            .call(api.addBrand(env, brandForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_BRAND`,
                        brand: data.brand,
                        brandId: data.brandId,
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: addBrand - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.env, ${
                                    data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message
                                }`,
                                'api.message.env, default',
                            ),
                            Translator.translate('api.message.env, intermediate_error'),
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: adBrand - ', error);
                throw error;
            });
    };
}

export function deleteBrand(env, brandId) {
    return dispatch => {
        return apiCaller
            .call(api.deleteBrand(env, brandId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__DELETE_BRAND`,
                        brandId,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteBrand - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Brands/actions.js